/**
 * In-memory access token store. Tokens must not be persisted to localStorage.
 */

let accessToken: string | null = null;

export const setAccessToken = (token: string | null | undefined): void => {
  accessToken = typeof token === "string" && token.trim() ? token.trim() : null;
};

export const getAccessToken = (): string | null => accessToken;

export const hasAccessToken = (): boolean => !!accessToken;

export const clearAccessToken = (): void => {
  accessToken = null;
};

/**
 * Remove token fields before persisting user profile to localStorage.
 */
export const stripTokensFromUserProfile = (
  profile: Record<string, unknown>
) => {
  if (!profile || typeof profile !== "object") return profile;
  const { accessToken: _a, refreshToken: _r, ...rest } = profile;
  return rest;
};
